import CreateComparisonModal from './CreateComparisonModal';

export default CreateComparisonModal;
